// extracted by mini-css-extract-plugin
export default {"root":"_19ErU","link-overlay":"n5D6r","linkOverlay":"n5D6r"};